export default [
  {
    path: '/entities',
    name: 'entities',
    component: () => import('./EntitiesManage.vue'),
    meta: {
      requiresAuth: true,
      is_admin: true,
      name: 'entities',
    },
  },
]
